import { useState } from 'react';
import { KeyRound, LogOut, Users } from 'lucide-react';
import { useAuth, useCurrentUser } from '../auth/AuthContext';
import { useT } from '../i18n';
import { ChangePasswordDialog } from './ChangePasswordDialog';
import { UsersPanel } from './UsersPanel';

/** Epic 14 — identita přihlášeného uživatele a vstupní body pro správu uživatelů/hesla, vedle `PreferencesToolbar`. */
export function UserBar() {
  const t = useT();
  const { logout } = useAuth();
  const user = useCurrentUser();
  const [usersOpen, setUsersOpen] = useState(false);
  const [passwordOpen, setPasswordOpen] = useState(false);

  return (
    <div className="preferences-toolbar">
      <span className="hint">{t('auth.loggedInAs', { name: user.displayName })}</span>
      <button type="button" className="preferences-toolbar__button" onClick={() => setUsersOpen(true)}>
        <Users size={16} />
        {t('users.button')}
      </button>
      <button type="button" className="preferences-toolbar__button" onClick={() => setPasswordOpen(true)}>
        <KeyRound size={16} />
        {t('password.change.button')}
      </button>
      <button type="button" className="preferences-toolbar__button" onClick={() => void logout()}>
        <LogOut size={16} />
        {t('auth.logout')}
      </button>

      {usersOpen && <UsersPanel onClose={() => setUsersOpen(false)} />}
      {passwordOpen && <ChangePasswordDialog onClose={() => setPasswordOpen(false)} />}
    </div>
  );
}
